import React from 'react';
import Horarios from "../../Components/Lista/Horarios";
import styled from "styled-components";
import { useHistory } from 'react-router-dom';
import BlueButton from '../../Components/BlueButton';

const Text=styled.h1`
margin:0;
justify-self:center;
font-size:24px;`;

const SubText=styled.h3`
text-align:center;
margin:0;
margin-top: 1rem;
justify-self:center;
font-size:20px;
font-weight:normal;

@media screen and (max-width:375px)
{
    font-size:17px;
}`;

const StatusVereda = ({Logo,CountWaiting}) => 
{
    const History=useHistory();
    let subText="";

    const Submit=()=>
    {
        History.push("/lista/cantidad")
    }

    if(CountWaiting===0)
    {
        subText=`Contamos con mesas disponibles adentro! Anotarse únicamente en caso de querer esperar un lugar en vereda o terraza (en estos momentos no hay grupos esperando un lugar al aire libre) 🍻🤙`;
    }
    if(CountWaiting===1)
    {
        subText=`Contamos con mesas disponibles adentro! Anotarse únicamente en caso de querer esperar un lugar en vereda o terraza (en estos momentos hay un grupo esperando un lugar al aire libre) 🍻🤙`;
    }
    if(CountWaiting>1)
    {
        subText=`Contamos con mesas disponibles adentro! Anotarse únicamente en caso de querer esperar un lugar en vereda o terraza (en estos momentos hay ${CountWaiting} grupos esperando un lugar al aire libre) 🍻🤙`;
    }


    return <>
           <div style={{display:"grid",justifyContent:"center",alignContent:"center"}}>
            {Logo}
            <Text>Lista de espera</Text>
            <SubText style={{marginTop:"20px", padding:"0px 30px", fontSize:"20px"}}>{subText}</SubText>
            <BlueButton onClick={Submit}>INGRESAR</BlueButton>
            <Horarios/>
        </div>  
    </>
    
}

export default StatusVereda
